import {useState} from 'react'
import {useSelector} from 'react-redux'
import {authorizationHeaderFromAccessToken} from '../auth'
import {API_URL} from '../config'
import {captureException} from '../errors'
import ServerError from '../errors/server'
import {getAccessToken} from '../store/authentication/authentication.selectors'

type Options = Readonly<{
  onError?: (error: Error) => void
  onSuccess?: () => void
}>

function useDeleteSponsorImage({onError, onSuccess}: Options = {}): {
  busy: boolean
  deleteSponsorImage: (sponsorId: string) => void
  error: Error | null
} {
  const accessToken = useSelector(getAccessToken)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const deleteSponsorImage = (sponsorId: string) => {
    setBusy(true)
    setError(null)

    fireDeleteSponsorImage(accessToken, sponsorId)
      .then(() => onSuccess?.())
      .catch(error => {
        captureException(error)
        setError(error)
        onError?.(error)
      })
      .finally(() => setBusy(false))
  }

  return {busy, deleteSponsorImage, error}
}

async function fireDeleteSponsorImage(
  accessToken: string,
  sponsorId: string
): Promise<void> {
  const url = new URL(`sponsors/${sponsorId}/images`, API_URL)

  const response = await fetch(url.toString(), {
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      ...authorizationHeaderFromAccessToken(accessToken)
    }
  })

  if (response.status !== 204) {
    throw await ServerError.fromResponse(response)
  }
}

export default useDeleteSponsorImage
